function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7249 1.87451C12.9439 1.09346 11.6776 1.09347 10.8965 1.87451L3.3048 9.46624C3.27993 9.4911 3.27993 9.53143 3.3048 9.55629L6.04316 12.2947C6.06803 12.3195 6.10835 12.3195 6.13322 12.2947L13.7249 4.70294C14.506 3.92189 14.506 2.65556 13.7249 1.87451ZM3.08869 10.8265C2.82586 10.5636 2.37833 10.6693 2.26079 11.0219L1.51175 13.2691C1.43422 13.5016 1.49475 13.758 1.6681 13.9314C1.84144 14.1047 2.09785 14.1652 2.33041 14.0877L4.57755 13.3387C4.93017 13.2211 5.03582 12.7736 4.77299 12.5108L3.08869 10.8265Z",
  fill: "#D8D8D8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7249 1.87451C12.9439 1.09346 11.6776 1.09347 10.8965 1.87451L3.3048 9.46624C3.27993 9.4911 3.27993 9.53143 3.3048 9.55629L6.04316 12.2947C6.06803 12.3195 6.10835 12.3195 6.13322 12.2947L13.7249 4.70294C14.506 3.92189 14.506 2.65556 13.7249 1.87451ZM3.08869 10.8265C2.82586 10.5636 2.37833 10.6693 2.26079 11.0219L1.51175 13.2691C1.43422 13.5016 1.49475 13.758 1.6681 13.9314C1.84144 14.1047 2.09785 14.1652 2.33041 14.0877L4.57755 13.3387C4.93017 13.2211 5.03582 12.7736 4.77299 12.5108L3.08869 10.8265Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1504_31262)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#444444"
}));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1504_31262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _ref3), _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.1942ad08.svg";
export { ForwardRef as ReactComponent };